import React from 'react';

const RadioInput = props => props.options.map((option) => {
	const {
		nameField,
		onChange,
		valueField,
		label,
	} = props;
	return (
		<div className="form-check" key={option.value}>
			<label className="form-check-label" htmlFor={nameField + option.value}>
				<input
					className="form-check-input css-radio"
					type="radio"
					value={option.value}
					id={nameField + option.value}
					name={nameField}
					onChange={onChange}
					checked={(valueField === option.value)}
				/>
				<i />
				{option.label}
				{
					(typeof option.image !== 'undefined')
						? (
							<div className="checkbox-image">
								<img src={option.image} alt={label} />
							</div>
						)
						: ''
				}
			</label>
		</div>
	);
});

export default RadioInput;
